import { useState, useEffect } from 'react';
import { COMPACT_CELL_WIDTH } from '../constants/breakpoints';

/** 7 列网格，gap-px 即 6px 缝隙 */
const GRID_COLS = 7;
const GAP_PX = 6;

/**
 * 根据日历网格容器宽度计算单格宽度，并判断是否进入紧凑模式
 */
export function useCalendarCellWidth(containerRef: React.RefObject<HTMLDivElement | null>): boolean {
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const update = () => {
      const w = el.offsetWidth;
      const cellWidth = (w - GAP_PX * (GRID_COLS - 1)) / GRID_COLS;
      setIsCompact(cellWidth < COMPACT_CELL_WIDTH);
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [containerRef]);

  return isCompact;
}
